<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" (click)="goBack()" >chevron_left</mat-icon>
            <h1 class="page-title">Detail CEU</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" (click)="goBack()">User</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" (click)="goBack()">{{user?.email}}</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">CEU</span>
        </div>
    </div>

    <hr class="mb-5" />

    <div class="container" *ngIf="ceu && ceu.certification">
        <div class="row">
            <div class="col-12">
                <b class="text-color-black-normal-50">Certification Title</b>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                {{ceu?.certification?.certificationTitle}}
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <b class="text-color-black-normal-50">Document Type</b>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                {{maskingColumn('parameterLabel', 'parameterValue', documentTypes.parameterMembers, ceu?.document?.documentType)}}
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <b class="text-color-black-normal-50">File</b>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                {{ceu?.document?.fileName}}
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <b class="text-color-black-normal-50">Activity Type</b>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                {{(activity?.activity?.activityType)? activity?.activity?.activityType : '-'}}
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <b class="text-color-black-normal-50">Validity Check</b>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                <div class="table-responsive-dark list-wrapper-bordered-dark">
                    <table class="table table-striped table-hover table-bordered" >
                        <thead>
                        <tr>
                            <th class="text-nowrap">Condition Name</th>
                            <th class="text-nowrap">Value If Valid</th>
                            <th class="text-nowrap">Your Answer</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let a of activity?.activity?.conditions">
                            <td class="text-nowrap">{{a?.conditionName}}</td>
                            <td class="text-nowrap">
                                {{maskingColumn('parameterLabel', 'parameterValue', integerLogics.parameterMembers, a?.integerOperator)}}
                                {{(a.conditionType == 'BOOLEAN')? ((a?.valueIfValid == 'true')? 'Yes':'No') : a?.valueIfValid}}
                            </td>
                            <td class="text-nowrap" style="color: #000;">
                                {{(a.conditionType == 'BOOLEAN')? ((a?.answer == 'true')? 'Yes':'No') : a?.answer}}
                            </td>
                        </tr>
                        <tr *ngIf="!activity?.activity?.conditions">
                            <td colspan="3" class="text-center">
                                <span>Validation response recorded</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <b class="text-color-black-normal-50">{{ activity?.activity?.completionQuestion }}</b>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                {{activity?.activity?.completionQuestionAnswer}} {{activity?.activity?.unitBase}}
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <b class="text-color-black-normal-50">Summary</b>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                {{(activity?.summary)? activity?.summary : '-'}}
            </div>
        </div>

    </div>

    <div class="container" *ngIf="ceu && !ceu.certification">
        <div class="row">
            <div class="col-12">
                Loading...
            </div>
        </div>
    </div>
</div>

